import { SizeDetails } from 'components/canvas/constants';
import TransformPoints from 'components/plateviewer/well/TransformPoints';
import { EFetchingStatusText } from 'components/plateviewer/well/WellImage/WellImage';
import { EFetchingStatus } from 'enums/EFetchingStatus';
import React from 'react';
import { Group, Image, Text } from 'react-konva';

interface Props {
  sizeDetails: SizeDetails;
  tpObject: TransformPoints;
  image: HTMLImageElement;
  imageStatus?: EFetchingStatus;
}

const WellImage = (props: Props) => {
  const { sizeDetails, tpObject, image, imageStatus } = props;

  return (
    <Group id='wellimage-group-wrapper'>
      <Text
        id='wellimage-text'
        x={0}
        y={0}
        width={sizeDetails.canvasWidth}
        height={sizeDetails.canvasHeight}
        fontSize={15}
        textAnchor="middle"
        text={EFetchingStatusText[imageStatus as EFetchingStatus]}
        align="center"
        verticalAlign="middle"
        wrap="none"
        fill="black"
      />
      <Image
        id='wellimage-image'
        height={tpObject ? tpObject.scalingHeight : 0}
        width={tpObject ? tpObject.scalingWidth : 0}
        image={image as CanvasImageSource}
        x={tpObject ? tpObject.leftMargin : 0}
        y={tpObject ? tpObject.topMargin : 0}
      />
    </Group>
  );
};

export default WellImage;
